// removed by extract-text-webpack-plugin
module.exports = {"container":"_1cPcODd-hv4Y64pTTMy8ot","option":"gFGTfZcYJtAYo35eRBpvW","icon":"_52mODsdWo90r0zmKJRiD1","title":"_36hMYYuMaJcNXoyQcQegfc"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/AdvancedSettings/Public/styles.css
// module id = 2824
// module chunks = 0